import {StateEffect} from '../../../../cm/state';

export const ShowMarkupGptEffect = StateEffect.define();
export const HideMarkupGptEffect = StateEffect.define();
